import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IntelligenceState {
	activeSection: string;
	contextDockOpen: boolean;
	detailPanelMetric: string | null;
	detailPanelOpen: boolean;
}

const initialState: IntelligenceState = {
	activeSection: "overview",
	contextDockOpen: false,
	detailPanelMetric: null,
	detailPanelOpen: false
};

export const intelligenceSlice = createSlice({
	initialState,
	name: "intelligence",
	reducers: {
		closeContextDock: (state) => {
			state.contextDockOpen = false;
		},
		closeDetailPanel: (state) => {
			state.detailPanelOpen = false;
		},
		openContextDock: (state) => {
			state.contextDockOpen = true;
		},
		openDetailPanel: (state) => {
			state.detailPanelOpen = true;
		},
		setActiveSection: (state, action: PayloadAction<string>) => {
			state.activeSection = action.payload;
		},
		setDetailPanelMetric: (state, action: PayloadAction<string | null>) => {
			state.detailPanelMetric = action.payload;
		}
	}
});

export const {
	closeContextDock,
	closeDetailPanel,
	openContextDock,
	openDetailPanel,
	setActiveSection,
	setDetailPanelMetric
} = intelligenceSlice.actions;

export default intelligenceSlice.reducer;
